import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

export const getAIAgentSettings = async websiteToken => {
  const urlData = endPoints.getAIAgentSettings(websiteToken);
  return API.get(urlData.url, { params: urlData.params });
};
